// E-Ticaret › Ödeme (Moka) Ayarları sayfası (taksit, vade farkı, dekont, kart formu) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.mokaSettings';

export const mokaPaymentSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'card',
  title: t(`${G}.title`, 'Moka ödeme ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu sayfada Moka United ile kartla ödemenin taksit, vade farkı, dekont ve kart formu ayarlarını yaparsınız. Moka bilgileriniz (DealerCode, Username, Password) önce Entegrasyonlar > Ödeme Entegrasyonları bölümünden eklenmiş olmalıdır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Moka Entegrasyonu'),
    strip: t(`${G}.regions.strip`, 'Kayıtlı Web Sitesi'),
    content: t(`${G}.regions.content`, 'Taksit, Vade Farkı, Dekont, Kart Formu'),
    summary: t(`${G}.regions.summary`, 'Banka Taksit Oranları'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kaydı seçin'),
      text: t(`${G}.s1.text`, 'Birden fazla Moka kaydınız varsa (şirket geneli ve şubeler) "Kayıt (Şube)" listesinden ayarlayacağınızı seçin; açılışta şirket geneli kayıt seçilir. Yanında kaydın Bayi Kodu, test modundaysa "Test Modu" etiketi görünür. Ayarlar yalnız seçili kayda kaydedilir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Hiç Moka kaydı yoksa sayfada yalnız bilgi kutusu çıkar; önce Entegrasyonlar > Ödeme bölümünden Moka bilgilerinizi ekleyin.'),
      ],
    },
    {
      region: 'strip',
      title: t(`${G}.s2.title`, '2. Kayıtlı web sitesi'),
      text: t(`${G}.s2.text`, '"Moka\'da tanımlı site adresi"ni yalnız Moka API bilgileriniz tek bir site için geçerliyse doldurun. Ödeme başka bir adreste başlarsa müşteri bu sitedeki güvenli ödeme sayfasına yönlendirilir. Vitrininiz zaten bu adresteyse boş bırakabilirsiniz.'),
    },
    {
      region: 'content',
      title: t(`${G}.s3.title`, '3. Taksit seçenekleri'),
      text: t(`${G}.s3.text`, '"Taksit Modu": "Müşteri taksit seçsin (önerilen)" müşteriye seçim bırakır; "Sabit taksit dayat" seçilince "Taksit Sayısı" (2–12) belirlenir. Müşteri seçiminde "Gösterilecek Taksitler" ile hangi seçeneklerin (Peşin dahil) sunulacağını işaretleyin; boş bırakırsanız tümü sunulur. Anahtarla ödeme ekranında kart numarasına göre banka taksit tablosunu gösterebilirsiniz.'),
    },
    {
      region: 'content',
      title: t(`${G}.s4.title`, '4. Vade farkı (komisyon)'),
      text: t(`${G}.s4.text`, '"Vade Farkı Modu" üç seçenektir: vade farkını mağaza üstlenir, tüm taksitlerde müşteriye yansır, ya da belirli takside kadar vade farksız, sonrası müşteriye ("Vade Farksız Taksit Sayısı" 1–11). Seçiminizin sonucunu altta çıkan açıklama anlatır.'),
      tips: [
        t(`${G}.s4.tip1`, '"Belirli takside kadar" modunu "Müşteri taksit seçsin" ile birlikte kullanıyorsanız çıkan sarı uyarıyı mutlaka okuyun: bu durumda sonuç Moka bayi panelinizdeki tanımlara bağlıdır.'),
      ],
    },
    {
      region: 'content',
      title: t(`${G}.s5.title`, '5. Dekont ve kart formu'),
      text: t(`${G}.s5.text`, '"Ödeme Sonrası Dekont" anahtarı açıkken ödeme başarılı ekranında müşteriye "Dekontu indir/yazdır" düğmesi çıkar; müşteri dekontu yazdırabilir veya PDF olarak kaydedebilir. Bu belge bilgi amaçlıdır; resmî mali belge (fatura/fiş) yerine geçmez. "Kart Formu Alanları"nda "Sadece zorunlu alanlar" açıkken TC, Ad-Soyad ve açıklama Moka\'ya gönderilmez; kapatırsanız Ad-Soyad ve e-postanın otomatik gönderilmesini ayrı ayrı açabilirsiniz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Bu anahtar yalnız bilgilerin gönderilip gönderilmeyeceğini belirler; Moka sayfasındaki kutuları kaldırmaz. Kutuların kalkması için Moka destekten bayi hesabınızda kapatılmasını isteyin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Oranları görün ve kaydedin'),
      text: t(`${G}.s6.text`, '"Banka taksit oranlarını getir" Moka bayi hesabınızda tanımlı komisyon oranlarını banka ve kart programına göre listeler; boş hücre o taksitin kapalı olduğunu gösterir. Ayarları "Kaydet" ile kaydedin; Moka kimlik bilgileri bu sayfada değişmez.'),
      tips: [
        t(`${G}.s6.tip1`, 'Kayıt test modundaysa oran tablosunun boş dönmesi normaldir; oranlar genelde canlı Moka bayi hesabında tanımlıdır.'),
      ],
    },
  ],
});
